import React from 'react'

const SortInfo = (props) => {
  let renderable

  switch(props.businessArea) {
    case 'schueleraustausch':
      renderable = (
        <small className='text text-muted'>
          Sortiert nach Anzahl eingegangener Bewertungen in den letzten 6 Monaten
        </small>
      )
      break
    case 'sprachreisen':
      renderable = (
        <small className='text text-muted'>
          Sortiert nach Anzahl Bewertungen
        </small>
      )
      break
    default:
      renderable=('')
  }

  return(
    <div className="col-12">
      <p className='text text-secondary'>
        <i className="bi bi-info-circle text-primary me-1"></i>{renderable}
      </p>
    </div>
  )
}

export default SortInfo
